import { appConfig, getAdminBrand } from '@planner/config';

/** Brand baked into this build (visual/copy only). */
export const brand = getAdminBrand(import.meta.env.VITE_BRAND ?? appConfig.defaultBrand);

/** API base URL; the local admin dev server (apps/admin-backend) mounts routes under /api. */
export const apiBaseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3132/api';

export const appVersion = import.meta.env.VITE_APP_VERSION ?? 'v0.0.0-local';

export const msalTenantId = import.meta.env.VITE_MSAL_TENANT_ID ?? '';
export const msalClientId = import.meta.env.VITE_MSAL_CLIENT_ID ?? '';

/**
 * Local-only auth bypass, mirroring the backend's AUTH_MODE=disabled. Only
 * honoured in vite dev mode so a production build can never ship without MSAL.
 */
export const authDisabled = import.meta.env.DEV && import.meta.env.VITE_AUTH_MODE === 'disabled';

export { appConfig };
